import axios from "axios";

const customAxios = axios.create({
  baseURL: process.env.VUE_APP_NODE_MANAGER_SERVER_URL+"api/admin/managers/",
});


import { multipart_headers } from "../state/helpers";
export const chargerManagementService = {
  getPublicCharger: (data) => window.axios.post("get-all-public-charger", data),
  getPrivateCharger: (data) =>
    window.axios.post("get-all-private-charger", data),
  getUsers: (data) => window.axios.post("get-users", data),
  showPublicCharger: (data) => window.axios.post("show-public-charger", data),
  deleteCharger: (data) => window.axios.post("delete-admin-charger", data),
  addOrUpdateCharger: (data) =>
    window.axios.post("add-or-update-charger", data, {
      headers: multipart_headers(),
    }),
  getMonthWiseBooking: (data) =>
    window.axios.post("get-month-wise-booking", data),
  getMonthWiseEarning: (data) =>
    window.axios.post("get-month-wise-earning", data),
  getAllChargersDetail: (data) =>
    window.axios.post("get-all-chargers-data", data),
  getManagers: (data) => 
     customAxios.get("get-all", data)
};
